<app-top-navigation [(isPacketOpen)]="isPacketOpen" [openLoginWindow]="isLoginOpen" *ngIf="currentSite"
                    [siteId]="currentSite.id"></app-top-navigation>
<app-panorama-container *ngIf="selectedPanorama"
                        [panoramic]="selectedPanorama.image"
                        [panoramichotspots]="sitePanoramicHotspots"
                        [haveLabels]="true"
                        [showCompass]="true"
                        [rotateX]="selectedPanorama.rotateX"
                        [rotateY]="selectedPanorama.rotateY"
                        [north_rotateY]="selectedPanorama.northRotateY"
                        (panoramaConfigurationChange)="handleConfigurationChange($event)"
                        (compassRotation)="rotationHandler($event)"
                        [enableCaching]="true"
                        style="position: absolute;width: 100%; height: 100%;"></app-panorama-container>
<div class="leftBottomButtons" *ngIf="currentSite">
    <div class="buttons" (click)="toggleMap()">
        <fa-icon [icon]="['fas','map-marked-alt']"></fa-icon>
    </div>
    <div class="buttons">
        <app-audio [audioUrl]="globalDataService.getObjectTranslation(currentSite.siteTranslations, 'audioPath')"></app-audio>
    </div>
    <div class="buttons" ngbDropdown>
        <fa-icon [icon]="['fas','layer-group']" ngbDropdownToggle></fa-icon>
        <div ngbDropdownMenu class="selections">
            <button ngbDropdownItem (click)="changePeriod(true)">{{'TRANS_REMOTE.TRANS_NOW' | translate}}</button>
            <button ngbDropdownItem (click)="changePeriod()">{{globalDataService.getObjectTranslation(currentSite.siteTranslations, 'century')}}</button>
        </div>
    </div>
</div>
<div class="mapContainer" [ngClass]="{'opened': isMapOpen}" *ngIf="currentSite">
    <div class="closeMap" (click)="toggleMap()">
        <fa-icon [icon]="['fas','times']"></fa-icon>
    </div>
    <app-simple-map *ngIf="monumentsMarkers$ | async as markers" [center]="[selectedPanorama.longitude, selectedPanorama.latitude]"
                    [rotatingMarkerCoords]="[selectedPanorama.longitude, selectedPanorama.latitude]"
                    [zoom]="17"
                    [currentRotation]="panoramicCenterRotation"
                    [generalMarkers]="markers"
                    (clickPoint)="clickPoint($event)"></app-simple-map>
</div>
<div class="monumentInformation" [class.fullWidth]="!isMapOpen" *ngIf="isMonumentOpen">
    <div class="closeInfo" (click)="toggleMonument()">
        <fa-icon [icon]="['fas','times']"></fa-icon>
    </div>
    <app-monument-detail [monument]="selectedMonument" [smallWindow]="isMapOpen"></app-monument-detail>
</div>
<div class="monumentDrawer">
    <div class="monumentContainer">
        <a (click)="openMonument(monument)" *ngFor="let
        monument of monuments$ |
         async">
            <div class="monument" container="body" placement="left"
                 ngbTooltip="{{globalDataService.getObjectTranslation(monument.monumentTranslations, 'name')}}">
                <div class="proFeature" *ngIf="!isSitePurchased()">{{ 'TRANS_REMOTE.TRANS_ONLY_PRO' | translate }}</div>
                <div class="monumentImage" [class.notPurchased]="!isSitePurchased()">
                    <img [src]="monument.centerImage | secure | async">
                </div>
            </div>
        </a>
    </div>
</div>
<app-site-packets [(isPacketOpen)]="isPacketOpen" *ngIf="isPacketOpen && currentSite" [siteId]="currentSite.id"></app-site-packets>
<div class="loaderContainer" *ngIf="flowLoading">
    <div class="loader-block" style="margin-top: 20%;">
        <svg id="loader2" viewBox="0 0 100 100">
            <circle id="circle-loader2" cx="50" cy="50" r="45"></circle>
        </svg>
    </div>
    <div>LOADING....</div>
</div>